import React, {FC, useRef, useEffect, forwardRef, useState} from 'react'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'

interface Props {
  label?: string
  disabled?: boolean
  value?: any
  change?: (value: any) => void
  height?: number
  placeholder?: string
  name?: string
  focus?: boolean
  smalltext?: string
  blur?: () => void
  onAction?: () => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void
  alarm?: boolean
  maxLength?: number
}

const Editor = forwardRef(
  (
    {
      defaultValue,
      onTextChange,
      onSelectionChange,
      change,
      height,
      maxLength,
      onCharCountChange, // novo
    }: any,
    ref: any
  ) => {
    const containerRef = useRef<any>(null)
    const defaultValueRef = useRef<any>(defaultValue)
    const onTextChangeRef = useRef<any>(onTextChange)
    const onSelectionChangeRef = useRef<any>(onSelectionChange)

    const [, setEditorContent] = useState<string>('')

    useEffect(() => {
      const container: any = containerRef.current
      const editorContainer = container.appendChild(container.ownerDocument.createElement('div'))

      const quill = new Quill(editorContainer, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{align: []}],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{indent: '-1'}, {indent: '+1'}],
            [{size: ['small', false, 'large', 'huge']}],
            [{header: [1, 2, 3, 4, 5, 6, false]}],
            ['link'],
            [{color: []}, {background: []}],
          ],
        },
      })

      ref.current = quill

      if (defaultValueRef.current) {
        quill.clipboard.dangerouslyPasteHTML(defaultValueRef.current)
      }

      quill.on(Quill.events.TEXT_CHANGE, (...args) => {
        onTextChangeRef.current?.(...args)
      })

      quill.on(Quill.events.SELECTION_CHANGE, (...args) => {
        onSelectionChangeRef.current?.(...args)
      })

      quill.on('text-change', (delta, oldDelta, source) => {
        const editor = ref.current
        if (editor) {
          let content = editor.root.innerHTML
          let plainText = editor.getText() || ''

          if (plainText.endsWith('\n')) {
            plainText = plainText.slice(0, -1)
          }

          if (onCharCountChange) {
            onCharCountChange(plainText.length)
          }

          if (maxLength && plainText.length > maxLength) {
            editor.deleteText(maxLength, editor.getLength())
            const newContent = editor.root.innerHTML
            change(newContent)
            setEditorContent(newContent)
            return
          }

          change(content)
          setEditorContent(content)
        }
      })

      return () => {
        ref.current = null
        container.innerHTML = ''
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, maxLength])

    return (
      <div
        style={{
          height: height ?? 200,
          marginBottom: '4rem',
        }}
        ref={containerRef}
      >
        <div id='editor' />
      </div>
    )
  }
)

const Delta = Quill.import('delta')

const EditorQuill: FC<Props> = (props) => {
  const {label, value, change, height, alarm, maxLength} = props

  const [, setRange] = useState()
  const [lastChange, setLastChange] = useState()
  const [charCount, setCharCount] = useState(0) // novo
  const quillRef = useRef()

  useEffect(() => {
    console.log(Delta)
  }, [lastChange])

  return (
    <div className='mt-4' style={{border: alarm ? '1px solid #d90429' : 'none'}}>
      {label && <label className='form-label fw-normal'>{label}</label>}
      <Editor
        ref={quillRef}
        defaultValue={value}
        onSelectionChange={setRange}
        onTextChange={setLastChange}
        change={(event: any) => change && change(event)}
        height={height}
        alarm={alarm}
        maxLength={maxLength}
        onCharCountChange={(count: number) => setCharCount(count)} // novo
      />
      {maxLength && (
        <div style={{textAlign: 'right', fontSize: '12px', color: '#666'}}>
          {charCount} / {maxLength}
        </div>
      )}
    </div>
  )
}

export {EditorQuill}
